var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20Signature = function Svg20Signature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 15.667q4.167-5.303 4.167-8.485C6.167 4 5.333 4 4.5 4S2.807 5.15 2.833 7.182c.029 2.172 1.382 5.172 2.084 6.364 1.25 2.12 2.083 2.651 2.916 1.06L9.5 11.424q.415 4.243 2.5 4.243c.442 0 2.2-2.121 2.5-2.121q.646 0 2.5 2.12"
  })));
};
export default Svg20Signature;